import { Inject, Injectable } from '@angular/core';
import { ID } from '@datorama/akita';
import { NgEntityService } from '@datorama/akita-ng-entity-service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { PersistState } from '@datorama/akita';

import { EmergencyVehicle } from '../../model/emergency-vehicle';
import { UpdateActionType } from '../../service/generic-akita-http.service';
import { WebsocketService } from '../../service/websocket.service';
import { encodeFiwareString } from '../../shared/replacer-util';
import { VehicleState, VehicleStore } from '../state/vehicle.store';
import { AkitaVehicleHttpService } from './akita-vehicle-http.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UrlConfig } from '../../model/urlconfig';

@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class VehicleService extends NgEntityService<VehicleState> implements UrlConfig {

  constructor(
    protected store: VehicleStore,
    private httpVehicleService: AkitaVehicleHttpService,
    private webSocketService: WebsocketService,
    @Inject('persistStorage') private persistStorage: PersistState
  ) {
    super(store);

    this.webSocketService.getDataStream('EmergencyVehicle')
      .pipe(untilDestroyed(this))
      .subscribe((data: EmergencyVehicle[]) => this.store.upsertMany(data));
  }
  updateEntitiesUrl(newUrl: string): void {
    this.httpVehicleService.setEntitiesUrl(newUrl);
  }


  getAll() {
    this.httpVehicleService.getAll().subscribe(vehicles => this.store.upsertMany(vehicles));
  }

  getById(id: ID) {
    this.httpVehicleService.loadById(id, {
      params: {
        options: 'keyValues',
        type: 'EmergencyVehicle'
      }
    }).subscribe(vehicles => this.store.add(vehicles));
  }

  updateLocal(vehicle: Partial<EmergencyVehicle>) {
    this.store.update(vehicle);
  }

  updateLocalAndRemote(vehicle: Partial<EmergencyVehicle>): Observable<boolean> {
    this.updateLocal(vehicle);

    const copy = { ...vehicle };
    copy.name = encodeFiwareString(vehicle.name);
    copy.description = encodeFiwareString(vehicle.description);
    copy.cameraConfig = encodeFiwareString(vehicle.cameraConfig);

    const options = {
      params: {
        options: 'keyValues',
      }
    };

    return this.httpVehicleService.update(copy, UpdateActionType.APPEND, options).pipe(map(s=>true));
  }
  updateFilteredStatusForVehicle(id: ID, selectedForFiltering: boolean) {
    this.store.ui.upsert(id, { isSelectedForFilter: selectedForFiltering });
  }

  resetFilteredStatusForAllVehicles() {
    this.store.ui.update(null, { isSelectedForFilter: false });
  }
}
